import React, { lazy, Suspense } from "react";

// import { ClipLoader } from "react-spinners";
import { Route, Routes, Navigate } from "react-router-dom";
import Layout from "./mainlayout";
import LoginPage from "../../Auth/Login/LoginPage";
// import Dashboard from '../../Pages/Dashboard/Dashboard';
import PrivateRoute from "./privateRoutes";
import ForgotPassword from "../../Auth/ForgotPassword/ForgotPassword";
// import Candidates from "../../Pages/Candidates/Candidates";
// import Recruiters from "../../Pages/Recruiters/Recruiters";
// import CandidateDetail from "../../Pages/Candidates/CandidateDetail";
// import RecruiterDetail from "../../Pages/Recruiters/RecruiterDetail";
// import Setting from "../../Pages/Setting/Setting";
// import Loader from "../Loader/Loader";
const Dashboard = lazy(() => import("../../Pages/Dashboard/Dashboard"));
const Candidates = lazy(() => import("../../Pages/Candidates/Candidates"));
const CandidateDetail = lazy(() =>import("../../Pages/Candidates/CandidateDetail"));
const Recruiters = lazy(() => import("../../Pages/Recruiters/Recruiters"));
const RecruiterDetail = lazy(() =>import("../../Pages/Recruiters/RecruiterDetail"));
const Setting = lazy(() => import("../../Pages/Setting/Setting"));
// const Dashboard = lazy(() => new Promise(resolve => setTimeout(() => resolve(import("../../Pages/Dashboard/Dashboard")), 2000)));

const Routings = () => {
  const routeData = [
    {
      path: "dashboard",
      element: <Dashboard />,
    },
    {
      path: "user-management",
      element: <Candidates />,
    },
    {
      path: "candidate/:id",
      element: <CandidateDetail />,
    },
    {
      path: "company-management",
      element: <Recruiters />,
    },
    {
      path: "company/:id",
      element: <RecruiterDetail />,
    },
    {
      path: "setting",
      element: <Setting />,
    },
  ];

  return (
    <Suspense fallback={".."}>
      <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="/" element={<PrivateRoute />}>
          <Route path="" element={<Layout />}>
            {routeData.map((data) => (
              <Route key={data.path} path={data.path} element={data.element} />
            ))}
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Suspense>
  );
};

export default Routings;
